import { z } from 'zod';

import { roleSchema } from './inviteRequests.ts';

/**
 * "Who is this org member" — originally just enough for the scheduling UI's provider field to show a
 * real confirmation once a colleague's user id was pasted in (`GET /api/orgs/members/:userId`), and
 * now also what a real provider *directory* returns (`GET /api/orgs/members`, `BACKLOG.md` K2's own
 * follow-up, closed 2026-08-18): every active member of the caller's own org, for the scheduling UI's
 * provider picker to render as `email (role)` instead of a pasted UUID nobody has looked at.
 *
 * One schema for both endpoints rather than a second, parallel shape — `role` was added here (and to
 * `findOrgMember`'s own query) specifically so the single-id lookup and the list share the exact same
 * wire shape instead of diverging. `email` is the only identifying field available at all:
 * `server/src/db/schema/platform.ts`'s `users` table has no name column — see this project's own
 * `CLAUDE.md` on why that stays true here (a name column is a real, separate schema change, out of
 * scope for this task).
 */
export const orgMemberSchema = z.strictObject({
  userId: z.uuid(),
  email: z.string(),
  role: roleSchema,
});
export type OrgMember = z.infer<typeof orgMemberSchema>;

export const orgMemberResponseSchema = z.strictObject({ member: orgMemberSchema });
export type OrgMemberResponse = z.infer<typeof orgMemberResponseSchema>;

/** Every active member of the caller's own org — the provider directory. */
export const orgMemberListResponseSchema = z.strictObject({ members: z.array(orgMemberSchema) });
export type OrgMemberListResponse = z.infer<typeof orgMemberListResponseSchema>;
